/* Generated by scripts/import-bibles.mjs. Do not edit manually. */
export const bibleBooks = [
  {
    "code": "GEN",
    "id": "genesis",
    "es": "Génesis",
    "en": "Genesis",
    "aliases": [
      "gen",
      "gn",
      "génesis",
      "genesis"
    ],
    "testament": "old",
    "chapterCount": 50
  },
  {
    "code": "EXO",
    "id": "exodus",
    "es": "Éxodo",
    "en": "Exodus",
    "aliases": [
      "ex",
      "exo",
      "éxodo",
      "exodus"
    ],
    "testament": "old",
    "chapterCount": 40
  },
  {
    "code": "LEV",
    "id": "leviticus",
    "es": "Levítico",
    "en": "Leviticus",
    "aliases": [
      "lv",
      "lev",
      "levítico",
      "leviticus"
    ],
    "testament": "old",
    "chapterCount": 27
  },
  {
    "code": "NUM",
    "id": "numbers",
    "es": "Números",
    "en": "Numbers",
    "aliases": [
      "nm",
      "num",
      "números",
      "numbers"
    ],
    "testament": "old",
    "chapterCount": 36
  },
  {
    "code": "DEU",
    "id": "deuteronomy",
    "es": "Deuteronomio",
    "en": "Deuteronomy",
    "aliases": [
      "dt",
      "deu",
      "deuteronomio",
      "deuteronomy"
    ],
    "testament": "old",
    "chapterCount": 34
  },
  {
    "code": "JOS",
    "id": "joshua",
    "es": "Josué",
    "en": "Joshua",
    "aliases": [
      "jos",
      "josué",
      "joshua"
    ],
    "testament": "old",
    "chapterCount": 24
  },
  {
    "code": "JDG",
    "id": "judges",
    "es": "Jueces",
    "en": "Judges",
    "aliases": [
      "jue",
      "jdg",
      "jueces",
      "judges"
    ],
    "testament": "old",
    "chapterCount": 21
  },
  {
    "code": "RUT",
    "id": "ruth",
    "es": "Rut",
    "en": "Ruth",
    "aliases": [
      "rut",
      "ruth"
    ],
    "testament": "old",
    "chapterCount": 4
  },
  {
    "code": "1SA",
    "id": "1-samuel",
    "es": "1 Samuel",
    "en": "1 Samuel",
    "aliases": [
      "1 sa",
      "1 sam",
      "1 samuel"
    ],
    "testament": "old",
    "chapterCount": 31
  },
  {
    "code": "2SA",
    "id": "2-samuel",
    "es": "2 Samuel",
    "en": "2 Samuel",
    "aliases": [
      "2 sa",
      "2 sam",
      "2 samuel"
    ],
    "testament": "old",
    "chapterCount": 24
  },
  {
    "code": "1KI",
    "id": "1-kings",
    "es": "1 Reyes",
    "en": "1 Kings",
    "aliases": [
      "1 re",
      "1 rey",
      "1 ki",
      "1 kings",
      "1 reyes"
    ],
    "testament": "old",
    "chapterCount": 22
  },
  {
    "code": "2KI",
    "id": "2-kings",
    "es": "2 Reyes",
    "en": "2 Kings",
    "aliases": [
      "2 re",
      "2 rey",
      "2 ki",
      "2 kings",
      "2 reyes"
    ],
    "testament": "old",
    "chapterCount": 25
  },
  {
    "code": "1CH",
    "id": "1-chronicles",
    "es": "1 Crónicas",
    "en": "1 Chronicles",
    "aliases": [
      "1 cr",
      "1 cro",
      "1 ch",
      "1 chronicles",
      "1 crónicas"
    ],
    "testament": "old",
    "chapterCount": 29
  },
  {
    "code": "2CH",
    "id": "2-chronicles",
    "es": "2 Crónicas",
    "en": "2 Chronicles",
    "aliases": [
      "2 cr",
      "2 cro",
      "2 ch",
      "2 chronicles",
      "2 crónicas"
    ],
    "testament": "old",
    "chapterCount": 36
  },
  {
    "code": "EZR",
    "id": "ezra",
    "es": "Esdras",
    "en": "Ezra",
    "aliases": [
      "esd",
      "ezr",
      "esdras",
      "ezra"
    ],
    "testament": "old",
    "chapterCount": 10
  },
  {
    "code": "NEH",
    "id": "nehemiah",
    "es": "Nehemías",
    "en": "Nehemiah",
    "aliases": [
      "neh",
      "nehemías",
      "nehemiah"
    ],
    "testament": "old",
    "chapterCount": 13
  },
  {
    "code": "EST",
    "id": "esther",
    "es": "Ester",
    "en": "Esther",
    "aliases": [
      "est",
      "ester",
      "esther"
    ],
    "testament": "old",
    "chapterCount": 10
  },
  {
    "code": "JOB",
    "id": "job",
    "es": "Job",
    "en": "Job",
    "aliases": [
      "job"
    ],
    "testament": "old",
    "chapterCount": 42
  },
  {
    "code": "PSA",
    "id": "psalms",
    "es": "Salmos",
    "en": "Psalms",
    "aliases": [
      "sal",
      "salmo",
      "salmos",
      "ps",
      "psalm",
      "psalms"
    ],
    "testament": "old",
    "chapterCount": 150
  },
  {
    "code": "PRO",
    "id": "proverbs",
    "es": "Proverbios",
    "en": "Proverbs",
    "aliases": [
      "pr",
      "prov",
      "proverbios",
      "proverbs"
    ],
    "testament": "old",
    "chapterCount": 31
  },
  {
    "code": "ECC",
    "id": "ecclesiastes",
    "es": "Eclesiastés",
    "en": "Ecclesiastes",
    "aliases": [
      "ec",
      "ecl",
      "eclesiastés",
      "ecclesiastes"
    ],
    "testament": "old",
    "chapterCount": 12
  },
  {
    "code": "SNG",
    "id": "song-of-songs",
    "es": "Cantar de los Cantares",
    "en": "Song of Songs",
    "aliases": [
      "cnt",
      "cantares",
      "song",
      "song of songs"
    ],
    "testament": "old",
    "chapterCount": 8
  },
  {
    "code": "ISA",
    "id": "isaiah",
    "es": "Isaías",
    "en": "Isaiah",
    "aliases": [
      "is",
      "isa",
      "isaías",
      "isaiah"
    ],
    "testament": "old",
    "chapterCount": 66
  },
  {
    "code": "JER",
    "id": "jeremiah",
    "es": "Jeremías",
    "en": "Jeremiah",
    "aliases": [
      "jer",
      "jeremías",
      "jeremiah"
    ],
    "testament": "old",
    "chapterCount": 52
  },
  {
    "code": "LAM",
    "id": "lamentations",
    "es": "Lamentaciones",
    "en": "Lamentations",
    "aliases": [
      "lam",
      "lamentaciones",
      "lamentations"
    ],
    "testament": "old",
    "chapterCount": 5
  },
  {
    "code": "EZK",
    "id": "ezekiel",
    "es": "Ezequiel",
    "en": "Ezekiel",
    "aliases": [
      "ez",
      "ezk",
      "ezequiel",
      "ezekiel"
    ],
    "testament": "old",
    "chapterCount": 48
  },
  {
    "code": "DAN",
    "id": "daniel",
    "es": "Daniel",
    "en": "Daniel",
    "aliases": [
      "dan",
      "daniel"
    ],
    "testament": "old",
    "chapterCount": 12
  },
  {
    "code": "HOS",
    "id": "hosea",
    "es": "Oseas",
    "en": "Hosea",
    "aliases": [
      "os",
      "hos",
      "oseas",
      "hosea"
    ],
    "testament": "old",
    "chapterCount": 14
  },
  {
    "code": "JOL",
    "id": "joel",
    "es": "Joel",
    "en": "Joel",
    "aliases": [
      "jl",
      "jol",
      "joel"
    ],
    "testament": "old",
    "chapterCount": 3
  },
  {
    "code": "AMO",
    "id": "amos",
    "es": "Amós",
    "en": "Amos",
    "aliases": [
      "am",
      "amo",
      "amós",
      "amos"
    ],
    "testament": "old",
    "chapterCount": 9
  },
  {
    "code": "OBA",
    "id": "obadiah",
    "es": "Abdías",
    "en": "Obadiah",
    "aliases": [
      "abd",
      "oba",
      "abdías",
      "obadiah"
    ],
    "testament": "old",
    "chapterCount": 1
  },
  {
    "code": "JON",
    "id": "jonah",
    "es": "Jonás",
    "en": "Jonah",
    "aliases": [
      "jon",
      "jonás",
      "jonah"
    ],
    "testament": "old",
    "chapterCount": 4
  },
  {
    "code": "MIC",
    "id": "micah",
    "es": "Miqueas",
    "en": "Micah",
    "aliases": [
      "mi",
      "mic",
      "miqueas",
      "micah"
    ],
    "testament": "old",
    "chapterCount": 7
  },
  {
    "code": "NAM",
    "id": "nahum",
    "es": "Nahúm",
    "en": "Nahum",
    "aliases": [
      "nah",
      "nam",
      "nahúm",
      "nahum"
    ],
    "testament": "old",
    "chapterCount": 3
  },
  {
    "code": "HAB",
    "id": "habakkuk",
    "es": "Habacuc",
    "en": "Habakkuk",
    "aliases": [
      "hab",
      "habacuc",
      "habakkuk"
    ],
    "testament": "old",
    "chapterCount": 3
  },
  {
    "code": "ZEP",
    "id": "zephaniah",
    "es": "Sofonías",
    "en": "Zephaniah",
    "aliases": [
      "sof",
      "zep",
      "sofonías",
      "zephaniah"
    ],
    "testament": "old",
    "chapterCount": 3
  },
  {
    "code": "HAG",
    "id": "haggai",
    "es": "Hageo",
    "en": "Haggai",
    "aliases": [
      "hag",
      "hageo",
      "haggai"
    ],
    "testament": "old",
    "chapterCount": 2
  },
  {
    "code": "ZEC",
    "id": "zechariah",
    "es": "Zacarías",
    "en": "Zechariah",
    "aliases": [
      "zac",
      "zec",
      "zacarías",
      "zechariah"
    ],
    "testament": "old",
    "chapterCount": 14
  },
  {
    "code": "MAL",
    "id": "malachi",
    "es": "Malaquías",
    "en": "Malachi",
    "aliases": [
      "mal",
      "malaquías",
      "malachi"
    ],
    "testament": "old",
    "chapterCount": 4
  },
  {
    "code": "MAT",
    "id": "matthew",
    "es": "Mateo",
    "en": "Matthew",
    "aliases": [
      "mt",
      "mat",
      "mateo",
      "matthew"
    ],
    "testament": "new",
    "chapterCount": 28
  },
  {
    "code": "MRK",
    "id": "mark",
    "es": "Marcos",
    "en": "Mark",
    "aliases": [
      "mc",
      "mar",
      "marcos",
      "mk",
      "mark"
    ],
    "testament": "new",
    "chapterCount": 16
  },
  {
    "code": "LUK",
    "id": "luke",
    "es": "Lucas",
    "en": "Luke",
    "aliases": [
      "lc",
      "luc",
      "lucas",
      "lk",
      "luke"
    ],
    "testament": "new",
    "chapterCount": 24
  },
  {
    "code": "JHN",
    "id": "john",
    "es": "Juan",
    "en": "John",
    "aliases": [
      "jn",
      "juan",
      "john"
    ],
    "testament": "new",
    "chapterCount": 21
  },
  {
    "code": "ACT",
    "id": "acts",
    "es": "Hechos",
    "en": "Acts",
    "aliases": [
      "hch",
      "hechos",
      "act",
      "acts"
    ],
    "testament": "new",
    "chapterCount": 28
  },
  {
    "code": "ROM",
    "id": "romans",
    "es": "Romanos",
    "en": "Romans",
    "aliases": [
      "ro",
      "rom",
      "romanos",
      "romans"
    ],
    "testament": "new",
    "chapterCount": 16
  },
  {
    "code": "1CO",
    "id": "1-corinthians",
    "es": "1 Corintios",
    "en": "1 Corinthians",
    "aliases": [
      "1 co",
      "1 cor",
      "1 corintios",
      "1 corinthians"
    ],
    "testament": "new",
    "chapterCount": 16
  },
  {
    "code": "2CO",
    "id": "2-corinthians",
    "es": "2 Corintios",
    "en": "2 Corinthians",
    "aliases": [
      "2 co",
      "2 cor",
      "2 corintios",
      "2 corinthians"
    ],
    "testament": "new",
    "chapterCount": 13
  },
  {
    "code": "GAL",
    "id": "galatians",
    "es": "Gálatas",
    "en": "Galatians",
    "aliases": [
      "ga",
      "gal",
      "gálatas",
      "galatians"
    ],
    "testament": "new",
    "chapterCount": 6
  },
  {
    "code": "EPH",
    "id": "ephesians",
    "es": "Efesios",
    "en": "Ephesians",
    "aliases": [
      "ef",
      "eph",
      "efesios",
      "ephesians"
    ],
    "testament": "new",
    "chapterCount": 6
  },
  {
    "code": "PHP",
    "id": "philippians",
    "es": "Filipenses",
    "en": "Philippians",
    "aliases": [
      "fil",
      "php",
      "filipenses",
      "philippians"
    ],
    "testament": "new",
    "chapterCount": 4
  },
  {
    "code": "COL",
    "id": "colossians",
    "es": "Colosenses",
    "en": "Colossians",
    "aliases": [
      "col",
      "colosenses",
      "colossians"
    ],
    "testament": "new",
    "chapterCount": 4
  },
  {
    "code": "1TH",
    "id": "1-thessalonians",
    "es": "1 Tesalonicenses",
    "en": "1 Thessalonians",
    "aliases": [
      "1 ts",
      "1 tes",
      "1 th",
      "1 tesalonicenses",
      "1 thessalonians"
    ],
    "testament": "new",
    "chapterCount": 5
  },
  {
    "code": "2TH",
    "id": "2-thessalonians",
    "es": "2 Tesalonicenses",
    "en": "2 Thessalonians",
    "aliases": [
      "2 ts",
      "2 tes",
      "2 th",
      "2 tesalonicenses",
      "2 thessalonians"
    ],
    "testament": "new",
    "chapterCount": 3
  },
  {
    "code": "1TI",
    "id": "1-timothy",
    "es": "1 Timoteo",
    "en": "1 Timothy",
    "aliases": [
      "1 ti",
      "1 tim",
      "1 timoteo",
      "1 timothy"
    ],
    "testament": "new",
    "chapterCount": 6
  },
  {
    "code": "2TI",
    "id": "2-timothy",
    "es": "2 Timoteo",
    "en": "2 Timothy",
    "aliases": [
      "2 ti",
      "2 tim",
      "2 timoteo",
      "2 timothy"
    ],
    "testament": "new",
    "chapterCount": 4
  },
  {
    "code": "TIT",
    "id": "titus",
    "es": "Tito",
    "en": "Titus",
    "aliases": [
      "tit",
      "tito",
      "titus"
    ],
    "testament": "new",
    "chapterCount": 3
  },
  {
    "code": "PHM",
    "id": "philemon",
    "es": "Filemón",
    "en": "Philemon",
    "aliases": [
      "flm",
      "phm",
      "filemón",
      "philemon"
    ],
    "testament": "new",
    "chapterCount": 1
  },
  {
    "code": "HEB",
    "id": "hebrews",
    "es": "Hebreos",
    "en": "Hebrews",
    "aliases": [
      "heb",
      "hebreos",
      "hebrews"
    ],
    "testament": "new",
    "chapterCount": 13
  },
  {
    "code": "JAS",
    "id": "james",
    "es": "Santiago",
    "en": "James",
    "aliases": [
      "stg",
      "santiago",
      "jas",
      "james"
    ],
    "testament": "new",
    "chapterCount": 5
  },
  {
    "code": "1PE",
    "id": "1-peter",
    "es": "1 Pedro",
    "en": "1 Peter",
    "aliases": [
      "1 pe",
      "1 ped",
      "1 peter",
      "1 pedro"
    ],
    "testament": "new",
    "chapterCount": 5
  },
  {
    "code": "2PE",
    "id": "2-peter",
    "es": "2 Pedro",
    "en": "2 Peter",
    "aliases": [
      "2 pe",
      "2 ped",
      "2 peter",
      "2 pedro"
    ],
    "testament": "new",
    "chapterCount": 3
  },
  {
    "code": "1JN",
    "id": "1-john",
    "es": "1 Juan",
    "en": "1 John",
    "aliases": [
      "1 jn",
      "1 juan",
      "1 john"
    ],
    "testament": "new",
    "chapterCount": 5
  },
  {
    "code": "2JN",
    "id": "2-john",
    "es": "2 Juan",
    "en": "2 John",
    "aliases": [
      "2 jn",
      "2 juan",
      "2 john"
    ],
    "testament": "new",
    "chapterCount": 1
  },
  {
    "code": "3JN",
    "id": "3-john",
    "es": "3 Juan",
    "en": "3 John",
    "aliases": [
      "3 jn",
      "3 juan",
      "3 john"
    ],
    "testament": "new",
    "chapterCount": 1
  },
  {
    "code": "JUD",
    "id": "jude",
    "es": "Judas",
    "en": "Jude",
    "aliases": [
      "jud",
      "judas",
      "jude"
    ],
    "testament": "new",
    "chapterCount": 1
  },
  {
    "code": "REV",
    "id": "revelation",
    "es": "Apocalipsis",
    "en": "Revelation",
    "aliases": [
      "ap",
      "apo",
      "apocalipsis",
      "rev",
      "revelation"
    ],
    "testament": "new",
    "chapterCount": 22
  }
] as const;
export const bibleSources = [
  {
    "id": "rv1909",
    "folder": "spaRV1909",
    "title": "Reina-Valera 1909",
    "shortTitle": "RV1909",
    "language": "es",
    "direction": "ltr",
    "testament": "both",
    "licenseId": "license-public-domain",
    "sourceUrl": "https://ebible.org/bible/details.php?id=spaRV1909",
    "version": "1909",
    "source": false
  },
  {
    "id": "web",
    "folder": "engwebp",
    "title": "World English Bible",
    "shortTitle": "WEB",
    "language": "en",
    "direction": "ltr",
    "testament": "both",
    "licenseId": "license-public-domain",
    "sourceUrl": "https://ebible.org/details.php?id=engwebp",
    "version": "2025",
    "source": false
  },
  {
    "id": "wlc",
    "folder": "hboWLC",
    "title": "Westminster Leningrad Codex",
    "shortTitle": "WLC",
    "language": "he",
    "direction": "rtl",
    "testament": "old",
    "licenseId": "license-public-domain",
    "sourceUrl": "https://hb.openscriptures.org/",
    "version": "4.20",
    "source": true
  },
  {
    "id": "sblgnt",
    "folder": "grcsbl",
    "title": "SBL Greek New Testament",
    "shortTitle": "SBLGNT",
    "language": "grc",
    "direction": "ltr",
    "testament": "new",
    "licenseId": "license-sblgnt",
    "sourceUrl": "https://github.com/LogosBible/SBLGNT",
    "version": "1.2",
    "source": true
  }
] as const;
